import { createContext, useContext } from 'react'
import { useCrud } from '../BackendProvider'
import { useRoles } from '../user/Auth'

export interface RunningCost {
    runningCostId?: number
    realm?: string
    tag: string
    vendor: string
    source: 'internal' | 'external'
    date: string
    amount: number
    vat: number
    currency: string
    comment: string
}

const RunningCostContext = createContext({
    runningCosts: [] as RunningCost[],
    postRunningCost: (_c: RunningCost) => Promise.resolve(_c),
    deleteRunningCost: (_c: RunningCost) => Promise.resolve({} as object),
})

export function RunningCostProvider({ children }: { children: React.ReactNode }) {
    const { hasCosts } = useRoles()
    const {
        data: runningCosts,
        postMutation: postRunningCost,
        deleteMutation: deleteRunningCost,
    } = useCrud<RunningCost>('running-cost', c => c.runningCostId, hasCosts)

    return (
        <RunningCostContext.Provider value={{ runningCosts, postRunningCost, deleteRunningCost }}>
            {children}
        </RunningCostContext.Provider>
    )
}

export function useRunningCosts() {
    return useContext(RunningCostContext)
}
